import Util from '@/helper/Utility.js';
import DTHelper from '@/helper/DatetimeHelper.js';

export function ShippingPriceModel() {
    this.startFirstname = '';
    this.startLastname = '';
    this.startLatitude = null;
    this.startLongtitude = null;
    this.startAddress = '';
    this.startContactNumber = null;
    this.startEmail = '';
    this.startRemark = '';
    this.endFirstname = '';
    this.endLastname = '';
    this.endLatitude = null;
    this.endLongtitude = null;
    this.endAddress = '';
    this.endAddressName = '';
    this.endSubdistrict = '';
    this.endDistrict = '';
    this.endProvince = '';
    this.endZipcode = '';
    this.endDirectionGuide = '';
    this.endContactNumber = null;
    this.endEmail = '';
    this.endRemark = '';
    this.packages = [];
    this.cod = 0;
    this.extra = { 
        Location: {
            ID: null,
            ReferenceCode: ''
        },
        ShippingDiscount:0,
        Discount: 0
    }
    this.tranId = null;
    this.refId = null;
    this.type = null;
    this.shippingPrice = 0;
    this.pickupFrom = '';

    this.setDelivery = (dict) => {
        var address = "";
        if (dict.address) {
            if (dict.address.number) {
                address += dict.address.number + " ";
            }
            if (dict.address.soi) {
                address += dict.address.soi + " ";
            }
            if (dict.address.subDistrictName) {
                address += dict.address.subDistrictName + " ";
            }
            if (dict.address.districtName) {
                address += dict.address.districtName + " ";
            }
            if (dict.address.zipcode) {
                address += dict.address.zipcode;
            }
            this.endLatitude = dict.address.lat;
            this.endLongtitude = dict.address.lng;
            this.endAddressName = dict.address.addressName;
            this.endSubdistrict = dict.address.subDistrictName;
            this.endDistrict = dict.address.districtName;
            this.endProvince = dict.address.provinceName;
            this.endZipcode = dict.address.zipcode;
            this.endDirectionGuide = dict.address.building;
        }
        
        if (dict.location) {
            this.startFirstname = dict.location.name;
            this.startLastname = dict.location.nameEN;
            this.startLatitude = dict.location.latitude;
            this.startLongtitude = dict.location.longtitude;
            this.startAddress = dict.location.address;
            this.extra.Location.ID = dict.location.id;
            this.extra.Location.ReferenceCode = dict.location.referenceCode;
        }
        this.endAddress = address;
        return this;
    }

    this.setDeliveryTime = (deliverTime) => {
        if (deliverTime === '') {
            this.pickupFrom = ''
        } else {
            this.pickupFrom =  DTHelper.timestampToFormatAddMinute(deliverTime, 'yyyy-MM-dd', -30) + 'T' + DTHelper.timestampToFormatAddMinute(deliverTime, 'HH:mm:ss', -30);
        }
        
        return this;
    }

    this.setProfile = (dict) => {
        this.endFirstname = dict.firstName;
        this.endLastname = dict.lastName;
        this.endContactNumber = dict.contactNumber;
        this.endEmail = dict.email;
        return this;
    }

    this.setDiscount = (discount) => {
        this.extra.Discount = discount;
        return this;
    }

    this.setShippingDiscount = (shippingDiscount) => {
        this.extra.ShippingDiscount = shippingDiscount;
        return this;
    }

    this.updateShippingFromCache = function (dict) {
        this.startFirstname = dict.startFirstname;
        this.startLastname = dict.startLastname;
        this.startLatitude = dict.startLatitude;
        this.startLongtitude = dict.startLongtitude;
        this.startAddress = dict.startAddress;
        this.startContactNumber = dict.startContactNumber;
        this.startEmail = dict.startEmail;
        this.startRemark = dict.startRemark;
        this.endFirstname = dict.endFirstname;
        this.endLastname = dict.endLastname;
        this.endLatitude = dict.endLatitude;
        this.endLongtitude = dict.endLongtitude;
        this.endAddress = dict.endAddress;
        this.endSubdistrict = dict.endSubdistrict;
        this.endDistrict = dict.endDistrict;
        this.endProvince = dict.endProvince;
        this.endZipcode = dict.endZipcode;
        this.endDirectionGuide = dict.endDirectionGuide;
        this.endContactNumber = dict.endContactNumber;
        this.endEmail = dict.endEmail;
        this.endRemark = dict.endRemark;
        this.packages = dict.packages;
        this.cod = dict.cod;
        this.extra = dict.extra;
        this.tranId = dict.tranId;
        this.refId = dict.refId;
        this.type = dict.type;
        this.shippingPrice = dict.shippingPrice;
        this.pickupFrom = dict.pickupFrom;
        return this;
    };

    this.setPackages = (dict) => {
        var arrCartItemAll = [];
        for (var cartItem of dict) {
            arrCartItemAll.push(cartItem.getPackagesForShipping());
        }
        
        this.packages = Util.toJsonStr(arrCartItemAll)
        return this;
    };

    /**
     * Get parameter for api.
    */
    this.getParams = () => {
        var params = {
            startFirstname: this.startFirstname,
            startLastname: this.startLastname,
            startLatitude: this.startLatitude,
            startLongtitude: this.startLongtitude,
            startAddress: this.startAddress,
            startContactNumber: this.startContactNumber,
            startEmail: this.startEmail,
            startRemark: this.startRemark,
            endFirstname: this.endFirstname,
            endLastname: this.endLastname,
            endLatitude: this.endLatitude,
            endLongtitude: this.endLongtitude,
            endAddress: this.endAddress,
            endAddressName: this.endAddressName,
            endSubdistrict: this.endSubdistrict,
            endDistrict: this.endDistrict,
            endProvince: this.endProvince,
            endZipcode: this.endZipcode,
            endDirectionGuide: this.endDirectionGuide,
            endContactNumber: this.endContactNumber,
            endEmail: this.endEmail,
            endRemark: this.endRemark,
            packages: this.packages,
            cod: this.cod,
            extra: Util.toJsonStr(this.extra),
            pickupFrom: this.pickupFrom
        }

        return params;
    };

    this.getParamsWithTranId = () => {
        var params = {
            startFirstname: this.startFirstname,
            startLastname: this.startLastname,
            startLatitude: this.startLatitude,
            startLongtitude: this.startLongtitude,
            startAddress: this.startAddress,
            startContactNumber: this.startContactNumber,
            startEmail: this.startEmail,
            startRemark: this.startRemark,
            endFirstname: this.endFirstname,
            endLastname: this.endLastname,
            endLatitude: this.endLatitude,
            endLongtitude: this.endLongtitude,
            endAddress: this.endAddress,
            endContactNumber: this.endContactNumber,
            endEmail: this.endEmail,
            endRemark: this.endRemark,
            packages: this.packages,
            cod: this.cod,
            extra: Util.toJsonStr(this.extra),
            tranId: this.tranId
        }

        return params;
    };

    this.getParamsForApiBookDriver = (sumShippingPrice) => {
        var params = {
            refId: this.refId,
            tranId: this.tranId,
            startRemark: this.startRemark,
            type: this.type,
            cod: sumShippingPrice,
        }

        return params;
    };

    this.getParamsForApiDriverStatus = () => {
        var params = {
            refId: this.refId,
        }

        return params;
    };

    this.getParamsForApiCancelDriver = () => {
        var params = {
            refId: this.refId,
            reason: 'force cancel by user'
        }

        return params;
    };
}

